import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Service/Offend/adversary-simulation/AdversarySimulation.tsx");
